import {
  IonHeader,
  IonToolbar,
  IonButton,
  IonCard,
  IonContent,
  IonItem,
  IonIcon,
  IonLabel,
  IonBadge,
  IonPage,
  IonText,
  IonFab, 
  IonFabButton, 
  IonList,
  IonImg,
  IonFabList,
  IonListHeader,
  IonSkeletonText,
  IonThumbnail,
  IonRefresher, 
  IonRefresherContent,
  useIonAlert,
  useIonModal,
  IonSegment,
  IonSegmentButton,
  IonCardContent,
  IonCardHeader,
  useIonLoading,
  IonGrid,
  IonRow,
  IonCol,
  IonChip,
  IonCardTitle,
  IonRadioGroup,
  IonRadio,
  IonTitle,
} from '@ionic/react';
import React, { useState } from 'react';
import { RefresherEventDetail } from '@ionic/core';
import { Preferences } from '@capacitor/preferences'
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import {
  LaunchNavigator,
  LaunchNavigatorOptions,
} from "@awesome-cordova-plugins/launch-navigator";
import { chevronDownCircleOutline, logIn, storefront, logOut, arrowBackOutline, menuSharp, locateOutline, mapOutline, cashOutline, walletOutline ,documentOutline, cartOutline, logInOutline, logOutOutline, chatboxEllipsesOutline, documentTextOutline, checkmarkCircleOutline, closeCircleOutline, addCircleOutline, bookOutline, starOutline, timeOutline, personOutline, navigateCircleOutline} from "ionicons/icons";
import { RestApi } from '../../services/Api';
import Map from '../Map';
import HistoryVisit from "./History";
import HistoryBill from "../bill/History";
import Ar from '../customer/Ar';
import Payment from '../customer/Payment';
import BackOrder from '../customer/BackOrder';
import Sales from '../customer/Sales';
import { useSelector, useDispatch } from "react-redux";
import { CustomerAction } from "../../data/state/CustomerReducer";
import { Visit } from '../../models/Modal';
import { useTranslation } from 'react-i18next';
import { dateToHour, getCollectByCustomer, getNameDate, getRoleMenu, returnElapsedTime, Rupiah, sumByCustomerKey, useConstructor } from '../../services/Library';
import Form from '../so/Form';
import SoDetail from "../so/Detail";
import SelectOption from '../input/SelectOption';
import { default as DetailBill } from "../bill/Detail";
import Contract from '../customer/Contract';
import CustomerDetail from '../customer/Detail';
import CustomerProfileForm from '../customer-profile/Form';
import './Detail.scss';

const isCpfUpdateExpired = (updateAt?: string | null) => {
  if (!updateAt) return true;
  const updated = new Date(updateAt);
  if (Number.isNaN(updated.getTime())) return true;
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  return updated < sixMonthsAgo;
};

const CUSTOMER_PHOTOS = [
  { key: "customer_identity_card_image", label: "KTP" },
  { key: "customer_image1", label: "Foto 1" },
  { key: "customer_image2", label: "Foto 2" },
  { key: "customer_image3", label: "Foto 3" },
  { key: "customer_image4", label: "Foto 4" },
] as const;

const InfoRow: React.FC<{ label: string; value?: string | number | null }> = ({
  label,
  value,
}) => (
  <>
    <p className="visit-detail-info-row">
      {label} :<strong> {value ?? "-"}</strong>
    </p>
    <hr className="visit-detail-divider" />
  </>
);

const Detail: React.FC<Visit> = (props) =>{
  const [alert] = useIonAlert();
  const dispatch = useDispatch();
  const { t } = useTranslation(["general"]);
  const customer = useSelector((state:any) => state.customer.value);
  const [visit, setVisit] = useState<any>([]);
  const [customerDetail, setCustomerDetail] = useState<any>(null);
  const [visitOn, setVisitOn] = useState<any>();
  const [loaded, setLoaded] = useState<boolean>(false);
  const [customerLoaded, setCustomerLoaded] = useState<boolean>(false);
  const user = useSelector((state: any) => state.user.value);
  const getRoleSo = getRoleMenu(user.role_menu, "so");
  const getRoleCustomerProfile = getRoleMenu(user.role_menu, "customer_profile");
  const [getIdSo, setGetIdSo] = useState<string>("");
  const [address, setAddress] = useState<any>();
  const [segment, setSegment] = useState<string>("visit");
  const [customerSegment, setCustomerSegment] = useState<string>("information");
  const [segmentImage, setSegmentImage] = useState<string>(
    "customer_identity_card_image"
  );
  const [bill, setBill] = useState<any>([]);
  const [getDetailBill, setGetDetailBill] = useState<any>([]);
  const [presentLoading, dismissLoading] = useIonLoading();
  const [baseUrl, setBaseUrl] = useState<string>('');
  let countTotal: number = 0;

  const [coordinates, setCoordinates] = useState<any>(null);

  React.useEffect(() => {
    if (Capacitor.isNative && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setCoordinates(pos);
        },
        () => {
          setCoordinates(null);
        }
      );
    }
  }, []);

  const massageAlert = async (status: string, body: string) => {
    alert({
      header: t(status),
      message: body,
      cssClass: `header-alert-${status}`,
      buttons: [{ text: t('yes'), handler: (d: any) => {} }],
    });
  };

  const navigateLocation = async (address: any) => {
    if (address?.customer_address_lat && address?.customer_address_lng) {
      if (Capacitor.isNative) {
        let options: LaunchNavigatorOptions = {
          start: `${coordinates?.coords?.latitude},${coordinates?.coords?.longitude}`,
          startName: "driving",
        };
        LaunchNavigator.navigate(
          [address?.customer_address_lat, address?.customer_address_lng],
          options,
        );
      } else {
        Browser.open({
          url: `https://www.google.com/maps/dir/?api=1&destination=${address?.customer_address_lat},${address?.customer_address_lng}`,
        });
      }
    } else {
      massageAlert("error", "Lokasi Pelanggan Belum Di Buat");
    }
  };

  const getCustomerDetail = (idCust: string) => {
    if (!idCust) return;
    setCustomerLoaded(false);
    RestApi(`customer/${idCust}`, "get", {}, "application/json")
      .then((res: any) => {
        if (res.data.code === 200) {
          setCustomerDetail(res.data.data);
          setCustomerLoaded(true);
        }
      })
      .catch(() => setCustomerLoaded(true));
  };

  const getVisitDetail = async (id:string,idCust:string) => {
      if (!id) {
        props.onDismissDetail()
        return;
      }
      const { value: visitOnVal } = await Preferences.get({ key: "visitOn" });
      const { value: urlVal } = await Preferences.get({ key: "url" });
      if (visitOnVal) setVisitOn(JSON.parse(visitOnVal));
      if (urlVal) setBaseUrl(urlVal);
      setLoaded(false)
      RestApi(`visit/detail-visit/${id}/${idCust}`,'get',{},'application/json')
      .then(async(res:any) => {
          if (res.data.code === 200) {
            setVisit(res.data.data)
            setLoaded(true)
          }else{
            props.onDismissDetail()
            massageAlert('error',res.data.message)
          }
      })
      .catch((err:any) => {
          props.onDismissDetail()
          massageAlert('error',err.message)
      });
  }

  const getBillList = async (idCust: string) => {
    if (!idCust || bill.length || visit.visit_hist?.length === 0) {
      return;
    }
    await presentLoading({ message: `${t("loading")}` });
    RestApi(`bill?customer_id=${idCust}`, "get", {}, "application/json")
      .then(async (res: any) => {
        if (res.data.code === 200) {
          setBill(res.data.data);
        } 
        dismissLoading();
      })
      .catch((err: any) => {
        massageAlert("error", err.message);
        dismissLoading();
      });
  };

  const checkStatus = (status:any) =>{
    switch(status) {
        case 0:
        return {
            color : 'danger',
            icon : logIn
        };
      case 1:
        return {
            color : 'success',
            icon : logOut
        };
      default:
        return {
            color : 'tertiary',
            icon : storefront
        };
    }
  }

  const doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    getVisitDetail(customer.visit_id,customer.customer_id);
    getCustomerDetail(props.detailVisit.customer_id);
    getBillList(props.detailVisit.customer_id);
    event.detail.complete();
  }

  const handleDismissMap = (e:any) => {
    getVisitDetail(props.detailVisit.visit_id,props.detailVisit.customer_id)
    dismissMap()
  }

  const handleDismissHistoryVisit = (e:any) => {
    dismissHistoryVisit();
  }

  const handleDismissHistoryBill = (e: any) => {
    dismissHistoryBill();
  };

  const handleDismissAr = (e:any) => {
    dismissAr()
  }

  const handleDismissPayment = (e:any) => {
    dismissPayment()
  }

  const handleDismissBackOrder = (e:any) => {
    dismissBackOrder()
  }

  const handleDismissSales = (e:any) => {
    dismissSales()
  }

  const handleDismissForm = () => {
    getVisitDetail(props.detailVisit.visit_id, props.detailVisit.customer_id);
    dismissForm();
  };

  const handleDismissVisitDetail = (e: any) => {
    dismissVisitDetail();
  };

  const handleDismissContract = (e: any) => {
    dismissContract();
  };

  const [presentVisitDetail, dismissVisitDetail] = useIonModal(SoDetail, {
    idSo: getIdSo,
    onDismiss: handleDismissVisitDetail,
  });

  const [presentBillDetail, dismissBillDetail] = useIonModal(DetailBill, {
    detailBill: getDetailBill,
    idVisit: props.detailVisit.visit_id,
    onDismissDetail: () => {
      dismissBillDetail();
    },
    type: "bill",
  });

  const [presentForm, dismissForm] = useIonModal(Form, {
    idSo: "",
    idVisit: props.detailVisit.visit_id,
    idCustomer: customer.customer_id,
    type: "create",
    onDismiss: handleDismissForm,
  });

  const [presentCustomerProfileForm, dismissCustomerProfileForm] =
    useIonModal(CustomerProfileForm, {
      idCustomerProfile: "0",
      idCustomer: props.detailVisit.customer_id,
      type: "create",
      onDismiss: () => {
        getCustomerDetail(props.detailVisit.customer_id);
        dismissCustomerProfileForm();
      },
    });

  const [presentMap, dismissMap] = useIonModal(Map, {
    customer: customer,
    type: "visit",
    visit: visit,
    address: address,
    bill: bill,
    onDismissDetail: handleDismissMap,
  });

  const [presentHistory, dismissHistoryVisit] = useIonModal(HistoryVisit, {
    idCustomer: customer.customer_id,
    onDismissDetail: handleDismissHistoryVisit,
  });

  const [presentHistoryBill, dismissHistoryBill] = useIonModal(HistoryBill, {
    idCustomer: customer.customer_id,
    onDismissDetail: handleDismissHistoryBill,
  });

  const [presentAr, dismissAr] = useIonModal(Ar, {
    idCustomer: customer.customer_id,
    onDismissDetail: handleDismissAr
  });

  const [presentPayment, dismissPayment] = useIonModal(Payment, {
    idCustomer: customer.customer_id,
    onDismissDetail: handleDismissPayment
  });

  const [presentBackOrder, dismissBackOrder] = useIonModal(BackOrder, {
    idCustomer: customer.customer_id,
    onDismissDetail: handleDismissBackOrder
  });
  
  const [presentSales, dismissSales] = useIonModal(Sales, {
      idCustomer: customer.customer_id,
      onDismissDetail: handleDismissSales
  });

  const [presentContract, dismissContract] = useIonModal(Contract, {
    idCustomer: customer.customer_id,
    onDismissDetail: handleDismissContract,
  });

  const [presentCustomerDetail, dismissCustomerDetail] = useIonModal(
    CustomerDetail,
    {
      idCustomer: props.detailVisit.customer_id,
      onDismissDetail: () => dismissCustomerDetail(),
    }
  );

  const [presentCustomerAddrresModal, dismissCustomerAddressModal] =
    useIonModal(SelectOption, {
      title: `${t("address")} ${t("module.customer")}`,
      items: visit?.customer_address?.map((value: any) => ({
        value: value.customer_address_id,
        text: `${value.customer_address_name}, ${value.customer_address}`,
      })),
      selectedItems: [],
      onSelectionCancel: () => dismissCustomerAddressModal(),
      onSelectionChange: (selected: string[]) => {
        addressSelectionChanged(selected);
        dismissCustomerAddressModal();
      },
      multiple: false,
    });

  const getSoDetail = async (id: string) => {
    setGetIdSo(id);
    presentVisitDetail({
      cssClass: "modal-fullscreen",
    });
  };

  const checkMap = () => {
    if (visitOn && visitOn.customer_id !== customer.customer_id) {
      alert({
        header: `Customer ${visitOn.customer_id} Belum Di Proses !`,
        message: `Sekarang Atau nanti?`,
        cssClass: 'header-alert',
        buttons: [
          {
                text: 'Nanti',
                cssClass: 'alert-button-cancel',
                role: 'cancel'
            },
            {
                text: 'Sekarang',
                cssClass: 'alert-button-confirm',
                role: 'confirm',
                handler:  () => {
                  dispatch(CustomerAction.setCustomer(visitOn))
                  getVisitDetail(visitOn.visit_id,visitOn.customer_id)
            },
        }]
      })
    }else{
      presentMap({
        cssClass: "modal-fullscreen",
      });
    }
  }

  const setValRadioAssessment = (val: any) => {
    if (!Array.isArray(val)) return undefined;
    return val.find((item: any) => item?.selected === true);
  };

  const getAssessmentList = (assessment: any): any[] => {
    if (Array.isArray(assessment)) return assessment;
    if (assessment && typeof assessment === "object") return [assessment];
    return [];
  };

  const addressSelectionChanged = (idAddress: string[]) => {
    setAddress(
      visit.customer_address.find(
        (val: any) => val.customer_address_id === idAddress
      )
    );
    checkMap();
    return;
  };
  
  useConstructor(() => {
    getVisitDetail(props.detailVisit.visit_id,props.detailVisit.customer_id);
    getCustomerDetail(props.detailVisit.customer_id);
    getBillList(props.detailVisit.customer_id);
  });

  return (
    <IonPage className="detail-content">
      <IonHeader>
        {loaded && customerLoaded && customerDetail ? (
          <IonToolbar class="toolbar-detail-visit ion-no-padding">
            <IonButton
              color="light"
              slot="start"
              fill="clear"
              onClick={() => props.onDismissDetail()}
            >
              <IonIcon color="light" slot="start" src={arrowBackOutline} />
            </IonButton>
            <IonItem className="ion-no-padding" lines="none">
              <IonLabel className="ion-no-padding" color="light">
                <h4>
                  <strong>
                    {customerDetail.customer_name} (
                    {customerDetail.customer_title})
                  </strong>
                </h4>
                <IonBadge color="dark" className="visit-detail-id-badge">
                  {customerDetail.customer_id}
                </IonBadge>
              </IonLabel>
              <IonIcon
                slot="end"
                className="visit-detail-status-icon"
                color={checkStatus(customer.visit_hist_type).color}
                src={checkStatus(customer.visit_hist_type).icon}
              />
            </IonItem>
          </IonToolbar>
        ) : (
          <IonToolbar class="toolbar-detail-visit ion-no-padding">
            <IonButton
              color="light"
              slot="start"
              fill="clear"
              onClick={() => props.onDismissDetail()}
            >
              <IonIcon color="light" slot="start" src={arrowBackOutline} />
            </IonButton>
            <IonItem className="ion-no-padding" lines="none">
              <IonLabel className="ion-no-padding" color="light">
                <IonSkeletonText
                  animated={true}
                  style={{ width: "70%", height: "18px" }}
                />
                <IonSkeletonText
                  animated={true}
                  style={{ width: "50%", height: "14px", marginTop: "6px" }}
                />
              </IonLabel>
            </IonItem>
          </IonToolbar>
        )}
      </IonHeader>
      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent
            pullingIcon={chevronDownCircleOutline}
            pullingText={`${t("loading")}`}
            refreshingSpinner="circles"
            refreshingText={`${t("loading")}`}
          ></IonRefresherContent>
        </IonRefresher>
        <IonCard className="visit-detail-segment-card ion-no-padding">
          <IonSegment
            scrollable={true}
            value={segment}
            className="ion-no-padding ion-no-margin visit-detail-segment"
          >
            <IonSegmentButton value="visit" onClick={() => setSegment("visit")}>
              <IonLabel>{t("visit")}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton
              value="customer"
              onClick={() => setSegment("customer")}
            >
              <IonLabel>{t("module.customer")}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton
              value="address"
              onClick={() => setSegment("address")}
            >
              <IonLabel>{t("address")}</IonLabel>
            </IonSegmentButton>
          </IonSegment>
          <IonCardContent className="ion-no-padding ion-no-margin">
            {segment === "customer" && (
              <>
                {customerLoaded && customerDetail ? (
                  <>
                    <IonSegment
                      scrollable={true}
                      value={customerSegment}
                      className="ion-no-padding ion-no-margin visit-detail-subsegment"
                    >
                      <IonSegmentButton
                        value="information"
                        onClick={() => setCustomerSegment("information")}
                      >
                        <IonLabel>{t("information")}</IonLabel>
                      </IonSegmentButton>
                      <IonSegmentButton
                        value="contact"
                        onClick={() => setCustomerSegment("contact")}
                      >
                        <IonLabel>{t("contact")}</IonLabel>
                      </IonSegmentButton>
                      <IonSegmentButton
                        value="assessment"
                        onClick={() => {
                          setCustomerSegment("assessment");
                        }}
                      >
                        <IonLabel>SPKO</IonLabel>
                      </IonSegmentButton>

                      <IonSegmentButton
                        value="detail"
                        onClick={() => setCustomerSegment("detail")}
                      >
                        <IonLabel>{t("detail")}</IonLabel>
                      </IonSegmentButton>
                    </IonSegment>
                    <IonCard className="visit-detail-customer-card">
                      <IonCardContent>
                        {customerSegment === "information" && (
                          <>
                            <IonText className="visit-detail-info-block">
                              <InfoRow
                                label="Handphone"
                                value={customerDetail.customer_phone}
                              />
                              <InfoRow
                                label="Telpon"
                                value={customerDetail.customer_phone}
                              />
                              <InfoRow
                                label="Fax"
                                value={customerDetail.customer_fax}
                              />
                              <InfoRow
                                label="Email"
                                value={customerDetail.customer_email}
                              />
                              <InfoRow
                                label="Status"
                                value={
                                  customerDetail.customer_is_active
                                    ? "AKTIF"
                                    : "TIDAK AKTIF"
                                }
                              />
                              <InfoRow
                                label="Area"
                                value={`${customerDetail.subarea_name} - ${customerDetail.area_name}`}
                              />
                              <InfoRow
                                label="Kota"
                                value={customerDetail.customer_city}
                              />
                              <InfoRow
                                label="Propinsi"
                                value={customerDetail.customer_state}
                              />
                              <InfoRow
                                label="Negara"
                                value={customerDetail.customer_country}
                              />
                              <InfoRow
                                label="Kode Pos"
                                value={customerDetail.customer_zipcode}
                              />
                              <p className="visit-detail-info-row">
                                Tipe :
                                <strong> {customer.customer_type_name}</strong>
                              </p>
                            </IonText>
                            <IonCard className="visit-detail-photo-card ion-no-padding ion-no-margin">
                              <IonTitle className="ion-padding-start ion-no-margin visit-detail-photo-title">
                                <strong>Foto Pelanggan</strong>
                              </IonTitle>
                              <IonCardContent className="ion-no-padding">
                                <IonSegment
                                  scrollable={true}
                                  value={segmentImage}
                                  className="visit-detail-photo-segment"
                                >
                                  {CUSTOMER_PHOTOS.map((photo) => (
                                    <IonSegmentButton
                                      key={photo.key}
                                      value={photo.key}
                                      onClick={() => setSegmentImage(photo.key)}
                                    >
                                      <IonLabel>{photo.label}</IonLabel>
                                    </IonSegmentButton>
                                  ))}
                                </IonSegment>
                                <IonImg
                                  className="visit-detail-photo-preview"
                                  src={
                                    customerDetail[segmentImage] ??
                                    "assets/img/image_not_available.png"
                                  }
                                  alt={
                                    CUSTOMER_PHOTOS.find(
                                      (p) => p.key === segmentImage,
                                    )?.label ?? ""
                                  }
                                />
                              </IonCardContent>
                            </IonCard>
                          </>
                        )}
                        {customerSegment === "contact" && (
                          <IonText className="visit-detail-info-block">
                            <InfoRow
                              label="Nama Kontak"
                              value={customerDetail.customer_contact_name}
                            />
                            <InfoRow
                              label="Tanggal Lahir"
                              value={getNameDate(
                                customerDetail.customer_contact_birthday,
                              )}
                            />
                            <InfoRow
                              label="Jabatan"
                              value={customerDetail.customer_contact_title}
                            />
                            <InfoRow
                              label="Hobby"
                              value={customerDetail.customer_contact_hobby}
                            />
                            <InfoRow
                              label="Handphone"
                              value={customerDetail.customer_contact_mobile}
                            />
                            <InfoRow
                              label="Email"
                              value={customerDetail.customer_contact_email}
                            />
                            <InfoRow
                              label="Nama KTP"
                              value={customerDetail.customer_identity_card_name}
                            />
                            <InfoRow
                              label="No. KTP"
                              value={
                                customerDetail.customer_identity_card_number
                              }
                            />
                            <InfoRow
                              label="Nama NPWP"
                              value={customerDetail.customer_tax_name}
                            />
                            <InfoRow
                              label="Nomor NPWP"
                              value={customerDetail.customer_tax_number}
                            />
                          </IonText>
                        )}
                        {customerSegment === "assessment" && (
                          <>
                            {getAssessmentList(customerDetail.assessment)
                              .length > 0 ? (
                              <IonCard className="visit-detail-spko-card ion-no-padding ion-no-margin">
                                <IonCardHeader className="ion-no-padding ion-no-margin">
                                  <IonItem>
                                    <IonText>
                                      <strong>SPKO</strong>
                                    </IonText>
                                    <IonText slot="end">
                                      <strong>Total</strong>
                                    </IonText>
                                  </IonItem>
                                </IonCardHeader>
                                <IonCardContent className="ion-no-padding ion-no-margin">
                                  {(() => {
                                    countTotal = 0;
                                    return getAssessmentList(
                                      customerDetail.assessment,
                                    ).map(
                                      (valAsType: any, keyAsType: number) => {
                                        let countSubTotal = 0;
                                        const typeItems = Array.isArray(
                                          valAsType.assessment,
                                        )
                                          ? valAsType.assessment
                                          : [];
                                        return (
                                          <IonCard key={keyAsType}>
                                            <IonCardHeader className="ion-no-padding ion-no-margin">
                                              <IonText>
                                                <strong>
                                                  {
                                                    valAsType.assessment_type_name
                                                  }
                                                </strong>
                                              </IonText>
                                            </IonCardHeader>
                                            <IonCardContent>
                                              {typeItems.map(
                                                (valAs: any, keyAs: number) => (
                                                  <div key={keyAs}>
                                                    <IonItem className="ion-no-padding ion-no-margin">
                                                      <IonText>
                                                        {valAs.assessment_name}
                                                      </IonText>
                                                      <IonText slot="end">
                                                        {
                                                          valAs.assessment_weight
                                                        }
                                                      </IonText>
                                                    </IonItem>
                                                    <IonList>
                                                      <IonRadioGroup
                                                        value={setValRadioAssessment(
                                                          valAs.assessment_value,
                                                        )}
                                                      >
                                                        {Array.isArray(
                                                          valAs.assessment_value,
                                                        ) &&
                                                          valAs.assessment_value.map(
                                                            (
                                                              value: any,
                                                              key: number,
                                                            ) => (
                                                              <IonItem
                                                                className="ion-no-padding ion-no-margin"
                                                                key={key}
                                                                lines="none"
                                                              >
                                                                <IonRadio
                                                                  disabled={
                                                                    true
                                                                  }
                                                                  className="ion-no-padding ion-no-margin"
                                                                  value={value}
                                                                  justify="space-between"
                                                                >
                                                                  <strong className="ion-text-wrap">
                                                                    {value.name}{" "}
                                                                    (
                                                                    {
                                                                      value.weight
                                                                    }
                                                                    )
                                                                  </strong>
                                                                </IonRadio>
                                                              </IonItem>
                                                            ),
                                                          )}
                                                      </IonRadioGroup>
                                                    </IonList>
                                                    <IonItem>
                                                      <IonText slot="end">
                                                        {(() => {
                                                          const selected =
                                                            setValRadioAssessment(
                                                              valAs.assessment_value,
                                                            );
                                                          const total =
                                                            Math.round(
                                                              selected
                                                                ? Number(
                                                                    selected.weight,
                                                                  ) *
                                                                    Number(
                                                                      valAs.assessment_weight,
                                                                    )
                                                                : 0,
                                                            );
                                                          countSubTotal +=
                                                            total;
                                                          countTotal += total;
                                                          return total.toFixed(
                                                            1,
                                                          );
                                                        })()}
                                                      </IonText>
                                                    </IonItem>
                                                  </div>
                                                ),
                                              )}
                                            </IonCardContent>
                                            <IonItem className="ion-no-padding ion-no-margin">
                                              <IonText slot="end">
                                                <strong>
                                                  Sub Total ={" "}
                                                  {countSubTotal.toFixed(1)}
                                                </strong>
                                              </IonText>
                                            </IonItem>
                                          </IonCard>
                                        );
                                      },
                                    );
                                  })()}
                                </IonCardContent>
                                <IonItem className="ion-no-padding ion-no-margin">
                                  <IonText slot="end" className="ion-text-end">
                                    <p className="ion-no-padding ion-no-margin">
                                      <strong>
                                        Total = {countTotal.toFixed(1)}
                                      </strong>
                                    </p>
                                    <hr className="visit-detail-divider" />
                                    <IonText color="primary">
                                      <p className="ion-no-padding ion-no-margin">
                                        {(() => {
                                          const indexSetting =
                                            customerDetail.setting?.find(
                                              (s: any) =>
                                                s.settings_id ===
                                                "setting_json_index_assessment",
                                            ) ?? customerDetail.setting?.[1];
                                          if (!indexSetting?.settings_value) {
                                            return "-";
                                          }
                                          const settingJson = JSON.parse(
                                            indexSetting.settings_value,
                                          );
                                          const item = [...settingJson]
                                            .sort(
                                              (a: any, b: any) =>
                                                Number(b.attaintement_rate) -
                                                Number(a.attaintement_rate),
                                            )
                                            .find(
                                              (row: any) =>
                                                countTotal >=
                                                Number(row.attaintement_rate),
                                            );
                                          return item
                                            ? `${item.class} - (${item.category}), ${item.decision}`
                                            : "-";
                                        })()}
                                      </p>
                                      <hr className="visit-detail-divider" />
                                    </IonText>
                                  </IonText>
                                </IonItem>
                                {(() => {
                                  const descSetting =
                                    customerDetail.setting?.find(
                                      (s: any) =>
                                        s.settings_id ===
                                        "settings_description_spko",
                                    ) ?? customerDetail.setting?.[0];
                                  if (!descSetting?.settings_value) return null;
                                  return (
                                    <IonItem className="ion-no-padding ion-no-margin">
                                      <div
                                        className="ion-no-padding ion-no-margin"
                                        dangerouslySetInnerHTML={{
                                          __html: descSetting.settings_value,
                                        }}
                                      />
                                    </IonItem>
                                  );
                                })()}
                              </IonCard>
                            ) : (
                              <IonText className="visit-detail-info-block ion-padding">
                                <p>Data SPKO belum tersedia</p>
                              </IonText>
                            )}
                          </>
                        )}
                        {customerSegment === "detail" && (
                          <IonText className="visit-detail-info-block">
                            <InfoRow
                              label="Website URL"
                              value={customerDetail.customer_url}
                            />
                            <InfoRow
                              label="Keterangan"
                              value={customerDetail.customer_remark}
                            />
                          </IonText>
                        )}
                      </IonCardContent>
                    </IonCard>
                    {getRoleCustomerProfile?.role_menu_add === 1 &&
                      isCpfUpdateExpired(customerDetail.customer_update_at) && (
                        <IonButton
                          expand="block"
                          color="warning"
                          size="small"
                          className="visit-detail-cpf-btn"
                          onClick={() =>
                            presentCustomerProfileForm({
                              cssClass: "modal-fullscreen",
                            })
                          }
                        >
                          Update CPF karena sudah lebih dari 6 bulan tidak ada
                          update
                        </IonButton>
                      )}
                  </>
                ) : (
                  <IonList>
                    <IonItem>
                      <IonLabel>
                        <IonSkeletonText animated style={{ width: "90%" }} />
                        <IonSkeletonText animated style={{ width: "70%" }} />
                        <IonSkeletonText animated style={{ width: "50%" }} />
                      </IonLabel>
                    </IonItem>
                  </IonList>
                )}
              </>
            )}
            {segment === "visit" && (
              <>
                {loaded ? (
                  <>
                    <IonCard className="visit-detail-visit-card ion-no-padding ion-no-margin">
                      <IonCardHeader className="visit-detail-section-header">
                        <IonIcon icon={documentTextOutline} color="primary" />
                        <IonText>
                          <strong>Keterangan</strong>
                        </IonText>
                      </IonCardHeader>
                      <IonCardContent>
                        <p>{visit.visitdet_remark ?? "-"}</p>
                      </IonCardContent>
                    </IonCard>

                    <IonCard className="visit-detail-timeline-card">
                      <IonGrid className="ion-no-padding">
                        <IonRow className="ion-align-items-center">
                          <IonCol size="6">
                            <IonChip
                              color="danger"
                              className="visit-detail-chip"
                            >
                              <IonIcon icon={logInOutline} />
                              <IonLabel>Check In</IonLabel>
                            </IonChip>
                            <p className="visit-detail-time">
                              {dateToHour(visit.visit_hist, 0)}
                            </p>
                          </IonCol>
                          <IonCol size="6" className="ion-text-end">
                            <IonChip
                              color="success"
                              className="visit-detail-chip"
                            >
                              <IonIcon icon={logOutOutline} />
                              <IonLabel>Check Out</IonLabel>
                            </IonChip>
                            <p className="visit-detail-time ion-text-end">
                              {dateToHour(visit.visit_hist, 1)}
                            </p>
                          </IonCol>
                        </IonRow>
                      </IonGrid>
                      <IonButton
                        expand="block"
                        className="visit-detail-duration-btn"
                      >
                        <IonIcon slot="start" icon={timeOutline} />
                        {returnElapsedTime(visit.visitdet_duration)}
                      </IonButton>
                    </IonCard>

                    <IonCard className="visit-detail-visit-card">
                      <IonCardHeader className="visit-detail-section-header">
                        <IonIcon
                          icon={chatboxEllipsesOutline}
                          color="primary"
                        />
                        <IonText>
                          <strong>{t("note")}</strong>
                        </IonText>
                      </IonCardHeader>
                      <IonCardContent>
                        <p>{visit.visitdet_note || "-"}</p>
                        <p className="visit-detail-offering-title">
                          <strong>{`${t("list")} ${t("offering")} ${t("product")}`}</strong>
                        </p>
                        <ul className="visit-detail-offering-list">
                          {visit.visitdet_offering &&
                          typeof visit.visitdet_offering === "object" &&
                          !Array.isArray(visit.visitdet_offering) ? (
                            Object.entries(
                              visit.visitdet_offering as Record<string, any>,
                            )
                              .sort(
                                (a, b) =>
                                  (a[1]?.grouping_sequence ?? 0) -
                                  (b[1]?.grouping_sequence ?? 0),
                              )
                              .map(([id, o]: [string, any]) => (
                                <li key={id}>
                                  {o?.grouping_name ?? "-"} - {o?.remark ?? "-"}
                                </li>
                              ))
                          ) : (
                            <li>-</li>
                          )}
                        </ul>
                        {visit.visit_image && visit.visit_image.length > 0 && (
                          <>
                            <p className="visit-detail-offering-title">
                              <strong>{t("image")}</strong>
                            </p>
                            <div className="detail-visit-images">
                              {visit.visit_image.map((img: any) => (
                                <div
                                  key={img.visitdet_image_id}
                                  className="detail-visit-image-item"
                                >
                                  <IonImg
                                    src={`${baseUrl}/image/visit/${user.company_id}/${img.visitdet_image_path}`}
                                    alt=""
                                  />
                                  {img.visitdet_image_note && (
                                    <p className="detail-visit-image-note">
                                      {img.visitdet_image_note}
                                    </p>
                                  )}
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </IonCardContent>
                    </IonCard>

                    <IonCard className="visit-detail-status-card ion-no-padding">
                      <IonItem
                        onClick={() => {
                          if (visit.visitdet_so_id) {
                            getSoDetail(visit.visitdet_so_id);
                          }
                        }}
                      >
                        <IonText className="ion-no-padding ion-no-margin">
                          <h4>
                            <strong>
                              Ada {t("module.so")} ? &nbsp;
                              <IonIcon
                                color={
                                  visit.visitdet_so_id ? "success" : "danger"
                                }
                                src={
                                  visit.visitdet_so_id
                                    ? checkmarkCircleOutline
                                    : closeCircleOutline
                                }
                              />
                            </strong>
                          </h4>
                        </IonText>

                        <IonText slot="end" className="ion-text-right">
                          <span>{visit.visitdet_so_id}</span>
                        </IonText>
                      </IonItem>
                      <IonItem
                        onClick={() => {
                          getBillList(props.detailVisit.customer_id);
                          setSegment("bill");
                        }}
                      >
                        <IonText className="ion-no-padding ion-no-margin">
                          <h4>
                            <strong>
                              {t("module.bill")} ? &nbsp;
                              <IonIcon
                                color={
                                  visit.visitdet_bill_id ? "success" : "danger"
                                }
                                src={
                                  visit.visitdet_bill_id
                                    ? checkmarkCircleOutline
                                    : closeCircleOutline
                                }
                              />
                            </strong>
                          </h4>
                        </IonText>

                        <IonText slot="end" className="ion-text-right">
                          <span>{visit.visitdet_bill_id}</span>
                        </IonText>
                      </IonItem>
                      <IonItem>
                        <IonText className="ion-no-padding ion-no-margin">
                          <h4>
                            <strong>
                              Check By &nbsp;
                              <IonIcon
                                color={
                                  visit.visitdet_is_visit ? "success" : "danger"
                                }
                                src={
                                  visit.visitdet_is_visit
                                    ? checkmarkCircleOutline
                                    : closeCircleOutline
                                }
                              />
                            </strong>
                          </h4>
                        </IonText>

                        <IonText slot="end" className="ion-text-right">
                          <span>{visit.visit_check_by}</span>
                          <span>
                            {visit.visit_check_at
                              ? getNameDate(visit.visit_check_at, true)
                              : "-"}
                          </span>
                        </IonText>
                      </IonItem>
                    </IonCard>
                    <IonCard>
                      <IonCardTitle className="ion-no-padding ion-no-margin ion-padding-start ion-margi-top">
                        <h4>
                          <strong>
                            {t("list")} {t("module.bill")}
                          </strong>
                        </h4>
                      </IonCardTitle>
                      <hr />
                      {loaded && Array.isArray(bill) && bill.length > 0 ? (
                        <IonList className="ion-no-padding ion-no-margin">
                          {bill.map((item: any, i: number) => {
                            const billdet = item.billdet ?? [];
                            return (
                              <IonCard
                                key={item.bill_id || i}
                                className="visit-detail-bill-card"
                                button
                                onClick={() => {
                                  setGetDetailBill(item);
                                  presentBillDetail({
                                    cssClass: "modal-fullscreen",
                                  });
                                }}
                              >
                                <IonCardHeader className="ion-no-padding">
                                  <IonItem>
                                    <IonBadge color="primary">
                                      {t("collect")} :{" "}
                                      {Rupiah(
                                        getCollectByCustomer(
                                          billdet,
                                          item.customer_id,
                                        ),
                                      )}
                                    </IonBadge>
                                  </IonItem>
                                </IonCardHeader>

                                <IonCardContent className="ion-no-padding">
                                  <IonGrid className="ion-no-padding visit-detail-bill-stats">
                                    <IonRow>
                                      <IonCol
                                        size="6"
                                        className="ion-no-padding"
                                      >
                                        <IonText>
                                          <p style={{ marginBottom: 4 }}>
                                            <small>
                                              {t("total")} {t("invoice")}
                                            </small>
                                            <br />
                                            <strong>
                                              {Rupiah(
                                                sumByCustomerKey(
                                                  item.customer_id,
                                                  billdet,
                                                  "billdet_si_total_amount",
                                                ),
                                              )}
                                            </strong>
                                          </p>
                                          <p style={{ marginBottom: 0 }}>
                                            <small>
                                              {t("jumlah")} {t("invoice")}
                                            </small>
                                            <br />
                                            <strong>{billdet.length}</strong>
                                          </p>
                                        </IonText>
                                      </IonCol>
                                      <IonCol
                                        size="6"
                                        className="ion-text-end ion-no-padding"
                                      >
                                        <IonText>
                                          <p style={{ marginBottom: 4 }}>
                                            <small>
                                              {t("sisa")} {t("owing")}
                                            </small>
                                            <br />
                                            <strong>
                                              {Rupiah(
                                                sumByCustomerKey(
                                                  item.customer_id,
                                                  billdet,
                                                  "billdet_si_total_owing",
                                                ),
                                              )}
                                            </strong>
                                          </p>
                                          <p style={{ marginBottom: 0 }}>
                                            <small>
                                              {t("total")} {t("payment")}
                                            </small>
                                            <br />
                                            <strong>
                                              {Rupiah(
                                                sumByCustomerKey(
                                                  item.customer_id,
                                                  billdet,
                                                  "billdet_si_total_payment",
                                                ) +
                                                  sumByCustomerKey(
                                                    item.customer_id,
                                                    billdet,
                                                    "billdet_si_total_allocate",
                                                  ),
                                              )}
                                            </strong>
                                          </p>
                                        </IonText>
                                      </IonCol>
                                    </IonRow>
                                  </IonGrid>
                                </IonCardContent>
                              </IonCard>
                            );
                          })}
                        </IonList>
                      ) : (
                        <IonText className="ion-text-center">
                          <p className="ion-no-padding ion-no-margin">
                            {t("not-found")} {t("module.bill")}
                          </p>
                        </IonText>
                      )}
                    </IonCard>
                  </>
                ) : (
                  <IonList>
                    <IonListHeader>
                      <IonSkeletonText
                        animated={true}
                        style={{ width: "80px" }}
                      ></IonSkeletonText>
                    </IonListHeader>
                    <IonItem>
                      <IonThumbnail slot="start">
                        <IonSkeletonText animated={true}></IonSkeletonText>
                      </IonThumbnail>
                      <IonLabel>
                        <h3>
                          <IonSkeletonText
                            animated={true}
                            style={{ width: "80%" }}
                          ></IonSkeletonText>
                        </h3>
                        <p>
                          <IonSkeletonText
                            animated={true}
                            style={{ width: "60%" }}
                          ></IonSkeletonText>
                        </p>
                        <p>
                          <IonSkeletonText
                            animated={true}
                            style={{ width: "30%" }}
                          ></IonSkeletonText>
                        </p>
                      </IonLabel>
                    </IonItem>
                  </IonList>
                )}
              </>
            )}
            {segment === "address" &&
              (
                customerDetail?.customer_address ?? visit?.customer_address
              )?.map((address: any) => (
                <IonCard
                  key={address.customer_address_id}
                  className="visit-detail-address-card"
                >
                  <IonCardContent>
                    <IonGrid className="ion-no-padding">
                      <IonRow className="ion-align-items-center">
                        <IonCol size="6">
                          <IonBadge
                            color={
                              address.customer_address_is_active === 1
                                ? "success"
                                : "danger"
                            }
                          >
                            {address.customer_address_is_active === 1
                              ? "Aktif"
                              : "InAktif"}
                          </IonBadge>
                        </IonCol>
                        <IonCol size="6" className="ion-text-end">
                          {address.customer_address_is_default === 1 && (
                            <IonIcon
                              icon={starOutline}
                              color="warning"
                              size="small"
                            />
                          )}
                          <IonIcon
                            icon={navigateCircleOutline}
                            size="small"
                            color="danger"
                            onClick={() => {
                              navigateLocation(address);
                            }}
                          />
                        </IonCol>
                        <IonCol size="12">
                          <IonText>
                            <h3 className="visit-detail-address-name">
                              {address.customer_address_name}
                            </h3>
                            <p className="visit-detail-address-text">
                              {address.customer_address}
                            </p>
                            <hr className="visit-detail-divider" />
                            <p className="visit-detail-address-meta">
                              Lat: {address.customer_address_lat}
                              <br />
                              Lng: {address.customer_address_lng}
                              <br />
                              Radius: {Number(
                                address.customer_address_radius,
                              )}{" "}
                              m
                            </p>
                          </IonText>
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  </IonCardContent>
                </IonCard>
              ))}
          </IonCardContent>
        </IonCard>
        {!loaded && (
          <IonList>
            <IonListHeader>
              <IonSkeletonText
                animated={true}
                style={{ width: "80px" }}
              ></IonSkeletonText>
            </IonListHeader>
            <IonItem>
              <IonThumbnail slot="start">
                <IonSkeletonText animated={true}></IonSkeletonText>
              </IonThumbnail>
              <IonLabel>
                <h3>
                  <IonSkeletonText
                    animated={true}
                    style={{ width: "80%" }}
                  ></IonSkeletonText>
                </h3>
                <p>
                  <IonSkeletonText
                    animated={true}
                    style={{ width: "60%" }}
                  ></IonSkeletonText>
                </p>
                <p>
                  <IonSkeletonText
                    animated={true}
                    style={{ width: "30%" }}
                  ></IonSkeletonText>
                </p>
              </IonLabel>
            </IonItem>
          </IonList>
        )}
      </IonContent>
      {loaded && (
        <IonFab horizontal="end" vertical="bottom">
          <IonFabButton className="fab-up" size="small">
            <IonIcon size="small" icon={menuSharp} />
          </IonFabButton>
          <IonFabList side="top">
            {props.type === "visit" && (
              <IonFabButton
                data-desc="Lokasi"
                onClick={() => {
                  if (visit.visit_hist[0]?.visit_hist_customer_address_id) {
                    setAddress(
                      visit.customer_address.find(
                        (val: any) =>
                          val.customer_address_id ===
                          visit.visit_hist[0].visit_hist_customer_address_id,
                      ),
                    );
                    checkMap();
                  } else {
                    presentCustomerAddrresModal({
                      initialBreakpoint: 0.9,
                      breakpoints: [0, 0.9, 1.0],
                      handleBehavior: "cycle",
                      backdropDismiss: true,
                      id: "modal-customer-address",
                      onWillDismiss: async () => {
                        const modalElement = document.getElementById(
                          "modal-customer-address",
                        ) as HTMLIonModalElement;
                        if (modalElement) {
                          modalElement?.dismiss();
                        }
                      },
                    });
                  }
                }}
              >
                <IonIcon icon={locateOutline} />
              </IonFabButton>
            )}
            {visit.visit_hist.length ? (
              <IonFabButton
                data-desc={`History ${t("module.bill")}`}
                onClick={() => {
                  presentHistoryBill({
                    cssClass: "modal-fullscreen",
                  });
                }}
              >
                <IonIcon size="medium" icon={bookOutline} />
              </IonFabButton>
            ) : (
              ""
            )}
            <IonFabButton
              data-desc={`History ${t("module.visit")}`}
              onClick={() => {
                presentHistory({
                  cssClass: "modal-fullscreen",
                });
              }}
            >
              <IonIcon size="medium" icon={mapOutline} />
            </IonFabButton>
            <IonFabButton
              data-desc="Daftar Piutang"
              onClick={() => {
                presentAr({
                  cssClass: "modal-fullscreen",
                });
              }}
            >
              <IonIcon icon={documentOutline} />
            </IonFabButton>
            <IonFabButton
              data-desc="Back Order"
              onClick={() => {
                presentBackOrder({
                  cssClass: "modal-fullscreen",
                });
              }}
            >
              <IonIcon size="medium" icon={cartOutline} />
            </IonFabButton>
            <IonFabButton
              data-desc="Pembayaran"
              onClick={() => {
                presentPayment({
                  cssClass: "modal-fullscreen",
                });
              }}
            >
              <IonIcon size="medium" icon={cashOutline} />
            </IonFabButton>
            <IonFabButton
              data-desc={`${t("module.so")}`}
              onClick={() => {
                presentSales({
                  cssClass: "modal-fullscreen",
                });
              }}
            >
              <IonIcon size="medium" icon={walletOutline} />
            </IonFabButton>
            {getRoleSo?.role_menu_add === 1 &&
            !visit.visitdet_so_id &&
            [0, 1].includes(customer.visit_hist_type) ? (
              <IonFabButton
                data-desc={`${t("create")} ${t("module.so")}`}
                onClick={() => {
                  presentForm({
                    cssClass: "modal-fullscreen",
                  });
                }}
              >
                <IonIcon icon={addCircleOutline} />
              </IonFabButton>
            ) : (
              ""
            )}
            <IonFabButton
              data-desc={t("contract")}
              onClick={() => {
                presentContract({
                  cssClass: "modal-fullscreen",
                });
              }}
            >
              <IonIcon icon={documentTextOutline} />
            </IonFabButton>
            <IonFabButton
              data-desc={`${t("detail")} ${t("module.customer")}`}
              onClick={() => {
                presentCustomerDetail({
                  cssClass: "modal-fullscreen",
                });
              }}
            >
              <IonIcon icon={personOutline} />
            </IonFabButton>
          </IonFabList>
        </IonFab>
      )}
    </IonPage>
  );
};

export default Detail;
